import React from 'react';

const Money = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_4398_25233)'>
        <path
          d='M25.0002 26.668H30.0002C30.9168 26.668 31.6668 25.918 31.6668 25.0013V15.0013C31.6668 14.0846 30.9168 13.3346 30.0002 13.3346H25.0002C24.0835 13.3346 23.3335 14.0846 23.3335 15.0013V25.0013C23.3335 25.918 24.0835 26.668 25.0002 26.668ZM26.6668 16.668H28.3335V23.3346H26.6668V16.668ZM15.0002 26.668H20.0002C20.9168 26.668 21.6668 25.918 21.6668 25.0013V15.0013C21.6668 14.0846 20.9168 13.3346 20.0002 13.3346H15.0002C14.0835 13.3346 13.3335 14.0846 13.3335 15.0013V25.0013C13.3335 25.918 14.0835 26.668 15.0002 26.668ZM16.6668 16.668H18.3335V23.3346H16.6668V16.668ZM8.3335 13.3346H11.6668V26.668H8.3335V13.3346ZM3.3335 6.66797V33.3346H36.6668V6.66797H3.3335ZM33.3335 30.0013H6.66683V10.0013H33.3335V30.0013Z'
          fill='#5A5955'
        />
      </g>
      <defs>
        <clipPath id='clip0_4398_25233'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Money;
